export const iconDropShadowStyle = {
  style: {
    filter:
      'drop-shadow(1px -2px 3px rgb(0 0 0 / 20%)) drop-shadow(0px 2px 2px rgb(0 0 0 / 14%)) drop-shadow(0px 1px 5px rgb(0 0 0 / 12%))',
  },
} as const;
